<!-- Category Picker Button -->

<template>
	<div class="cat-pick-btn" @click="clickShowCatPopup()">
		<div class="cat-pick-img">
			<img :src="calcImgUrl('min', cat.icoMin)" v-if="cat.icoMin" />
		</div>
		<div class="cat-pick-title">
			{{cat.title}} 
		</div>
	</div>
</template>

<script>
import { m } from "@/utils/utils"
import { mapState } from 'vuex';
import { eventBus } from '@/main';

export default {
	data() {
		return {
			cat: {},
		}
	},
	props: {
		step: {type: String, default: "current"},
	},
	computed: {
		...mapState('app', ['current', 'upload', 'search']),
		...mapState('api', ['source']),
	},
	methods: {
		calcImgUrl(itype, file_name) {
			return this.source.url + this.source.ico + 'cat/' + itype + '/' + file_name;
		},
		clickShowCatPopup() {
			m("click set cat");
			let payload = {
				popType: "door",
				popTitle: "Choose Category",
				popText: "This is the door text.",
				compName: "CatPick",
				compData: {
					step: this.step,
				},
			};
			eventBus.$emit("popup", payload);			
		},
	},
	created() {
		this.cat = this[this.step].cat;
		m("cat pick btn created: " + this.step, this.cat);
	},
	watch: {
		"current.cat": {
			handler: function(newValue, oldValue) {
				if (this.step==="current") {
					m("btn cat is now", newValue);
					this.cat = newValue;
				}
			},
		},
		"upload.cat": {
			handler: function(newValue, oldValue) {
				if (this.step==="upload") {
					m("btn cat is now", newValue);
					this.cat = newValue;
				}
			},
		},
		"search.cat": {
			handler: function(newValue, oldValue) {
				if (this.step==="search") {
					m("btn cat is now", newValue);
					this.cat = newValue;
				}
			},
		},
	},
}
</script>

<style scoped>

.cat-pick-btn {
	display: inline-block;
	width: 180px;
	height: 42px;
	overflow: hidden;
	vertical-align: top;
	white-space: nowrap;
	font-family: inherit;
	font-size: 16px; 
	text-align: left;
	cursor: pointer;
	padding: 4px 0px 0px 10px;
	background-color: #DDD;
	border: solid 1px #999;		
	border-top: solid 2px #FFF;
	border-left: solid 2px #FFF;
	/* border-radius: 4px; */
	border-bottom-right-radius: 7px;
}
.cat-pick-img {
	display: inline-block;
	width: 32px;
	height: 32px;
	overflow: hidden;
	border: solid 0px #66C;		
}
.cat-pick-title {
	display: inline-block;
	width: 130px;
	height: 30px;
	overflow: hidden;
	white-space: nowrap;
	text-align: left;
	vertical-align: top;
	padding: 6px 0px 0px 15px;
	border: solid 0px #C60;		
}

</style>
